<template>
  <div v-if="loading">
    <MoonLoader class="loading"></MoonLoader>
  </div>

  <div v-else>
    <card-total>
      <div slot="title">
        <div class="cardCustom__header">
          <div class="cardCustom__header-text">
            <span class="uppercase"> Recommendations </span>
          </div>
          <div class="cardCustom__header-info__item">
            <button
              v-tooltip="{
                content: 'Top 3 Recommendations for your club',
                placement: 'bottom-center',
                classes: ['info'],
              }"
            >
              <i class="fas fa-info-circle" />
            </button>
          </div>
        </div>
      </div>
      <div slot="content">
        <paper-table :data="tableData" :columns="tableColumns" type="hover" @clicked="moveToElement($event)">
        </paper-table>
      </div>
    </card-total>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CardSummary from '@/components/Cards/CardSummary';
import CardTotal from '@/components/Cards/CardTotal';
import PaperTable from '@/components/PaperTable';
import RecommendationsController from '@/controllers/DashboardElement/RecommendationsController';
import DefineController from '@/controllers/Question/DefineController';
export default {
  name: 'DashboardElementRecommendations',
  components: { PaperTable, CardTotal, CardSummary, MoonLoader },
  props: {
    summary: Object,
  },
  data() {
    return {
      loading: false,
      summaryCopy: null,
      categoryCopy: null,
      tableColumns: ['Name', 'Impact', 'Category'],
      tableData: [],
    };
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  async mounted() {
    this.loading = true;
    let tableData = await this.getTableData();
    await this.setTableData(tableData);
    this.loading = false;
  },
  methods: {
    getValueClass() {
      return 'success';
    },
    async getTableData() {
      return await RecommendationsController.index();
    },
    async setTableData(tableData) {
      tableData.sort(function (a, b) {
        return b.question.question_weight - a.question.question_weight;
      });
      let result = tableData.map(function (answer) {
        return {
          id: answer.id,
          name: answer.dashboard_element.headline,
          impact: DefineController.defineImpact(answer.question.question_weight),
          category: answer.question.category.name,
          question_text: answer.question.question_text,
          question_type: answer.question.question_type,
        };
      });
      this.tableData = result.slice(0, 3);
    },
    moveToElement(index) {
      this.$gtag.event('Recommendations Clicked', { method: 'Google' });
      let category = this.tableData[index].category;
      if (category === 'education and policies') category = 'policies';
      console.log(this.tableData[index]);
      this.$router.push({
        path: '/manage_answers/' + this.company.company_id,
        query: {
          company: this.company,
          selectedQuestionType: this.tableData[index].question_type,
          searchBy: this.tableData[index].question_text,
        },
      });
    },
  },
};
</script>

<style scoped></style>
